import React from 'react';

import { FilterList } from './filter-list';
import { ButtonTitle, StyledFilterButton, StyledFilterButtonListItem } from './styled';

export enum FilterType {
  EXCLUSIONARY = 'Excluded:',
  INCLUSIONARY = 'Included:',
  NONE = 'No filters applied',
}

export type FilterButtonProps = {
  filterType: FilterType;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  selectedOptions?: string[];
  title: string;
};

export function FilterButton({ filterType, onClick, selectedOptions, title }: FilterButtonProps) {
  return (
    <StyledFilterButtonListItem>
      <StyledFilterButton onClick={onClick}>
        <ButtonTitle>{title}</ButtonTitle>
        <FilterList filterType={filterType} selectedOptions={selectedOptions} />
      </StyledFilterButton>
    </StyledFilterButtonListItem>
  );
}
